
const OkaimaOhizua = () => {

  return (
    <div className="w-full min-h-screen bg-white">
      <div className="relative bg-[#14532d] text-white py-8 md:py-10 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative z-10">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight uppercase tracking-tight">
          Okaima Ohizua
          </h2>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 py-8 font-sans text-gray-800">
        <section>
          <div className="max-w-6xl mx-auto p-8 bg-white font-sans text-gray-700">
            <div className="flex flex-col md:flex-row gap-12">

              {/* Left Side: Image */}
              <div className="md:w-1/3">
                <div className="sticky top-24">
                  <div className="relative group">
                    <div className="absolute -inset-1 bg-gradient-to-r from-green-700 to-yellow-400 rounded-2xl blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200"></div>
                    <img
                      src="/images/okaima.jpeg"
                      alt="Kings C. Akuma"
                      className="relative w-full h-auto object-cover rounded-2xl shadow-2xl border-4 border-white"
                    />
                  </div>
                </div>
              </div>

              {/* Right Side: Content */}
              <div className="md:w-2/3">
                {/* Name and Title */}
                <header className="mb-12">
                  <h1 className="text-4xl font-black text-black mb-6 uppercase tracking-tight">PROFILE</h1>
                  <div className="text-lg leading-relaxed space-y-6 text-gray-600 font-medium">
                    <p>
                    Okaima Ohizua is a board-level executive with over 33 years of leadership across banking, hospitality, and power, recognized for driving corporate governance, operational excellence, and organizational transformation.          
                    </p>
                    <p>
                    Okaima Ohizua is a distinguished board-level executive with over 33 years of cross-sector leadership experience spanning the banking, hospitality, and power sectors. Throughout her career, she has held key roles including Non-Executive Director, Chief Operating Officer, and Executive Director, establishing a strong reputation for driving operational excellence, organizational transformation, and robust corporate governance.Currently, Okaima serves on the Board of BEDC Electricity Plc, where she chairs the Board Corporate Governance Committee. Her leadership journey includes significant tenures at reputable institutions such as Citibank (NIB), United Bank for Africa (UBA), Transcorp Hotels Plc, and Transcorp Power Plc. 
                    </p>
                    <hr className="border-gray-100 mb-12" />
                    <p>
                    During her time at Transcorp Hotels, she made history as the first female Executive Board member, where she spearheaded service transformation initiatives that garnered international recognition, including the prestigious Kaizen award for operational excellence.  Beyond her corporate achievements, Okaima has demonstrated a commitment to high-level strategic public service. She notably served as Secretary to the FCT Ministerial Committee on the Operational Review of Homes and Related Child Welfare, a role that required complex multi-stakeholder coordination across government, regulatory, and security agencies.
                    </p>
                    <hr className="border-gray-100 mb-12" />
      
                    <p>
                    Okaima’s professional approach is grounded in a strong legal foundation. She holds an LL.B (Barrister-at-Law) and a Master’s in IT Law, which provide her with a unique perspective on regulatory frameworks and digital-era governance. She is also an alumnus of the Lagos Business School (Advanced Management Program) and holds memberships with the Institute of Directors (IoD) Nigeria and WIMBIZ.  Recognized as one of the "Top 50 Leading Ladies in Corporate Nigeria" by Leading Ladies Africa, Okaima is deeply passionate about mentoring, gender equality, and building institutions that prioritize sustainability and customer-centricity.                
                     </p>
                    <hr className="border-gray-100 mb-12" />
      
                    <p>
                    She is a committed advocate for integrity and character, dedicated to enhancing service delivery and strengthening governance structures to achieve impactful outcomes.                    </p>
                    <hr className="border-gray-100 mb-12" />
                  </div>
                </header>


              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default OkaimaOhizua;